import IOperaton from '../../IOperation'

/**
 * 临近分析基类
 * 规定数据格式
 * 不做其他处理
 */
export default class INear extends IOperaton {
    /**
     * @description 处理
     * @api
     * @param {{type:'FeatureCollection', features:[]}} featureCollections 要素集一
     */
    async _process(featureCollections, ...rest) {}
}
